<div class="flex-column justify-btw" style="width: 100%; height: 100%; padding-top: 10px">
  <div class="flex-row-reverse" style="margin-right: 10px">
    <img class="log" src="../../../../assets/icone/log.svg" (click)="abrirLog()" />
  </div>

  <iframe style="width: 100%; height: 94%;" [src]="data.documento.urlArquivo"></iframe>
</div>
